import React from "react";
import { Star, ExternalLink } from "lucide-react";
import LpCta from "./LpCta";
import { pushGtmEvent } from "@/lib/gtm";
import { REVIEWS, GOOGLE_BUSINESS_URL } from "./lpData";

const Stars = ({ size = 18 }) => (
  <div className="flex gap-1">
    {[0, 1, 2, 3, 4].map((s) => (
      <Star key={s} size={size} className="text-[#00C4FF]" fill="#00C4FF" strokeWidth={0} />
    ))}
  </div>
);

const LpReviews = () => (
  <section className="section-pad bg-[#E6F8FF]" data-testid="lp-reviews">
    <div className="aevos-container">
      <div className="max-w-3xl">
        <Stars size={30} />
        <h2 className="font-display font-bold text-3xl md:text-5xl mt-4 leading-[1.08]" data-testid="lp-reviews-title">
          5 estrelas no Google
        </h2>
        <p className="mt-5 text-[#333333] text-base md:text-lg leading-relaxed">
          Conheça relatos sobre a atenção na consulta, a clareza das orientações e a experiência de
          acompanhamento com o Dr. Guilherme.
        </p>
      </div>

      <div className="mt-12 grid md:grid-cols-3 gap-5">
        {REVIEWS.map((r, i) => (
          <article key={r.name} className="aevos-card bg-white p-7 flex flex-col" data-testid={`lp-review-${i}`}>
            <Stars />
            <p className="mt-5 text-[#333333] italic text-sm md:text-[0.95rem] leading-relaxed flex-1">
              &ldquo;{r.text}&rdquo;
            </p>
            <div className="mt-6 pt-5 border-t border-[#E0E0E0] flex items-center gap-4">
              <div className="w-11 h-11 bg-black !text-white flex items-center justify-center font-display font-bold text-sm tracking-wider">
                {r.initials}
              </div>
              <div>
                <p className="font-display font-semibold text-black text-sm">{r.name}</p>
                <p className="text-xs text-[#666] mt-0.5">{r.role} · Avaliação no Google</p>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-12 flex flex-col sm:flex-row sm:items-center gap-4">
        <LpCta location="reviews">Agendar minha consulta</LpCta>
        <a
          href={GOOGLE_BUSINESS_URL}
          target="_blank"
          rel="noreferrer"
          className="btn-ghost"
          data-testid="lp-google-reviews-link"
          onClick={() => pushGtmEvent("google_reviews_click", { location: "lp_reviews" })}
        >
          Ver todas as avaliações no Google
          <ExternalLink size={16} />
        </a>
      </div>
    </div>
  </section>
);

export default LpReviews;
